import {
  USER_INFO,
  RECORD_INFO,
  CURRENT_APP
} from '../mutation-types.js'

const state = {
  systemName: '拓天晟物流资源共享平台',
  userInfo: {

  },
  app: {}
}

const mutations = {
  [USER_INFO] (state, newData) {
    state.userInfo = newData
  },
  [RECORD_INFO] (state, newData) {
    state.frontUserInfo = newData
  },
  [CURRENT_APP] (state, newData) {
    state.app = newData
  }
}

export default {
  state,
  mutations
}
